import { CarrierLogo, Row, Typography } from '@/components'
import { paths } from '@/routes/paths'
import { useGoToPath } from '@/utils'
import { ChevronRight } from 'lucide-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { InsuranceCellContainer, InsuranceCellTextContainer } from './styles'
import { getInsuranceCategoryNameKey } from '@/utils/insuranceCategory'

type InsuranceCellProps = {
  categoryId: string
  insuranceId: string
  locationId: string
  logoUrl: string
}

const InsuranceCell = ({
  categoryId,
  insuranceId,
  locationId,
  logoUrl,
}: InsuranceCellProps) => {
  const { t } = useTranslation()
  const goToInsurance = useGoToPath(
    paths.viewInsuranceWithKey({ categoryId, insuranceId, locationId }),
  )

  const category = useMemo(() => {
    return t(getInsuranceCategoryNameKey(categoryId))
  }, [categoryId, t])

  return (
    <InsuranceCellContainer onClick={goToInsurance}>
      <CarrierLogo height="32px" name={logoUrl} width="32px" />
      <InsuranceCellTextContainer>
        <Row alignItems="center">
          <Typography bold title={category} variant="badgeText">
            {category}
          </Typography>
          <ChevronRight size={24} />
        </Row>
      </InsuranceCellTextContainer>
    </InsuranceCellContainer>
  )
}

export default InsuranceCell
